import { Platform } from './types';

/**
 * Resolve the API base URL for the active platform. Discord Activity uses
 * `<origin>/.proxy/api` (CSP requires absolute URL combined with iframe
 * origin); other platforms honor `VITE_API_URL` with dev fallback.
 */
export const getApiBaseUrl = (platform: Platform): string => {
  if (platform === Platform.Discord) {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/.proxy/api`;
  }
  const fromEnv = (import.meta as { env?: Record<string, string | undefined> }).env?.VITE_API_URL;
  return fromEnv ?? 'http://localhost:3000';
};
